import type { AssetApprovalChain } from '../model/types';
import { i18n } from '@/shared/i18n';

export interface ChainStepProgress {
  approved: number;
  total: number;
  isComplete: boolean;
}

export function getChainStepProgress(chain: AssetApprovalChain): ChainStepProgress {
  const steps = chain.workflowDefinition.steps;

  return {
    approved: steps.filter((step) => step.isCompleted).length,
    total: steps.length,
    isComplete: chain.status === 'completed',
  };
}

export function chainStepsApprovedLabel(progress: ChainStepProgress): string {
  return i18n.t('projects:assetApprovalChain.chainProgressUtils.stepsApproved', {
    approved: progress.approved,
    total: progress.total,
  });
}

export function chainStepsApprovedAnnouncement(progress: ChainStepProgress): string {
  return i18n.t('projects:assetApprovalChain.chainProgressUtils.stepsApprovedAnnouncement', {
    approved: progress.approved,
    count: progress.total,
  });
}
